import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { PageContainer } from "~/components/layout/PageContainer";
import { AppHeader } from "~/components/layout/AppHeader";
import { RaffleNoMorePlaying } from "~/assets/raffle/RaffleNoMorePlaying";
import { Button } from "@shadcn/ui/button";

export const Route = createFileRoute("/$hubMetaName/raffle/no-more-playing")({
	beforeLoad: () => {
		document.title = 'bacehub | Startseite'
	},
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = useNavigate();
	const i18n = useI18nContext().LL["new-ui"];

	const handleBackToHome = () => {
		navigate({ to: "/" });
	};

	return (
		<PageContainer
			footer={
				<Button className="w-full shadow-xl" size="lg" onClick={handleBackToHome}>
					Back to homepage
				</Button>
			}
		>
			<AppHeader service="RAFFLE" />
			<div className="flex flex-col items-center gap-4 px-6">
				<div className="flex flex-col justify-start items-start gap-2 py-4">
					<h2 className="text-2xl text-neutral-900">
						<T>{i18n.RAFFLE_NO_MORE_PLAYING_TITLE()}</T>
					</h2>
					<p className="text-sm text-muted-foreground">
						<T>{i18n.RAFFLE_NO_MORE_PLAYING_DESC()}</T>
					</p>
				</div>
				<div className="flex justify-center items-center">
					<RaffleNoMorePlaying />
				</div>
			</div>
		</PageContainer>
	);
}
